// Module
var code = "<page-header title=\"'Service list'\" breadcrumbs=\"['Services']\" reload=\"true\"> </page-header>\r\n\r\n<docker-services-datatable\r\n  dataset=\"services\"\r\n  title-icon=\"shuffle\"\r\n  on-refresh=\"(getServices)\"\r\n  is-add-action-visible=\"true\"\r\n  is-stack-column-visible=\"true\"\r\n  table-key=\"'services'\"\r\n></docker-services-datatable>\r\n";
// Exports
var _module_exports = code;;
var path = 'app/docker/views/services/services.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;